<app-dark-bottom-svg></app-dark-bottom-svg>
<div class="container-fluid bg-dark-black pb-5 pt-3">
  <div class="row text-center text-light animate-to-top">
    <div class="col-12">
      <h1>About</h1>
    </div>
  </div>
  <div class="row pt-3">
    <div class="text-light text-center col-12 col-lg-5">
      <div class="animate-to-top">
        <img class="w-100 px-5" src="../../assets/sumantImage.jpg" alt="" />
      </div>
      <h1 class="animate-to-top">Sumant Mishra</h1>
      <h4 class="animate-to-top">Front end developer</h4>
      <div class="animate-to-top border-bottom pb-4 pt-1 mx-5">
        <i class="mx-1 fa-2x fa fa-twitter"></i>
        <i class="mx-1 fa-2x fa fa-github"></i>
      </div>
      <div class="animate-to-top">
        <p class="mt-3 mb-0" (click)="downloadResume()">
          <a>DOWNLOAD CV</a>
          <i class="ml-1 text-light fa fa-download" aria-hidden="true"></i>
        </p>
      </div>
    </div>
    <div class="text-light px-4 text-center text-md-left col-12 col-lg-7">
      <h3 class="animate-to-top">Hi_</h3>
      <p class="animate-to-top">
        I am Web developer able to build a Web presence from the ground up -
        from concept, navigation, layout and programming to UX and SEO. Skilled
        at writing well-designed, testable and efficient code using current best
        practices in Web development. Fast learner, hard worker and team player
        who is proficient in an array of scripting languages and multimedia Web
        tools.
      </p>
      <div class="animate-to-top row mt-4 mb-5">
        <div class="col-12 col-md-6">
          <p><b>AGE: </b>.... 25</p>
          <p><b>FREELANCE: </b>.... AVAILABLE</p>
        </div>
        <div class="col-12 col-md-6">
          <p><b>RESIDENCE: </b>.... INDIA</p>
          <p><b>ADDRESS: </b>.... DEWAS, (M.P.),455001</p>
        </div>
      </div>
      <div class="animate-to-top row">
        <div class="col-12 pb-2 border-bottom">
          <h2>Pricing</h2>
        </div>
      </div>
      <div class="animate-to-top row mt-5 text-dark text-center">
        <div class="col-12 col-md-6">
          <div class="card bg-gray text-light pricing-box-shadow">
            <div class="card-body">
              <i class="fa fa-battery-half fa-2x" aria-hidden="true"></i>
              <h6><b>Basic</b></h6>
              <div>
                <span class="dollar">$</span>
                <span class="number">20</span>
                <span class="period"> hour</span>
              </div>
              <div class="mt-4 border-bottom">
                <p>UI Development</p>
                <p>Responsive Web Development</p>
                <p><del>Full Stack Development</del></p>
                <p>Code Optimization</p>
                <p><del>Code Quality</del></p>
                <p>Project Deployment</p>
                <p>Installation</p>
                <p>Maintainance</p>
                <p><del>VCS</del></p>
              </div>
              <div class="mt-4 mb-3">
                <a (click)="scrollPage('contact')"><b>Buy Pro</b></a>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 mt-md-0 col-12 col-md-6">
          <div class="card bg-gray text-light pricing-box-shadow">
            <div class="card-body">
              <i class="fa fa-battery-full fa-2x" aria-hidden="true"></i>
              <h6><b>Pro</b></h6>
              <div>
                <span class="dollar">$</span>
                <span class="number">35</span>
                <span class="period"> hour</span>
              </div>
              <div class="mt-4 border-bottom">
                <p>UI Development</p>
                <p>Responsive Web Development</p>
                <p>Full Stack Development</p>
                <p>Code Optimization</p>
                <p>Code Quality</p>
                <p>Project Deployment</p>
                <p>Installation</p>
                <p>Maintainance</p>
                <p>VCS</p>
              </div>
              <div class="mt-4 mb-3">
                <a (click)="scrollPage('contact')"><b>Buy Basic</b></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
